import React from 'react';
import { TextArea, TextField, Flex } from "@radix-ui/themes";
import { useStore } from '../../store/store';
import avatar from '../../assets/avatar2.png';

export const Information = ({ 
    title,
    setTitle,
    topic, 
    setTopic, 
    styleAndTone, 
    setStyleAndTone, 
    otherInstructions, 
    setOtherInstructions 
}) => {
    const [state, actions] = useStore();
    return (
        <div>
            {state.novels.length === 0 ?
            <Flex className="tutorial-container" style={{ }}>
                <Flex className={"tutorial-text"}>
                    <img src={avatar} alt="Avatar" className="tutorial-avatar" />
                    <div>Pick a title, and describe what you're book is about.<br />You can also define the style & tone of the book, as well as give general instructions to the AI.<br />(Don't worry, you can always change these later!)</div>
                </Flex>
            </Flex> : null}

            <div className="mb-4">
                <h3 className="details-label">Title</h3>
                <TextField.Root
                    className="create-input"
                    placeholder="Enter the title of your non-fiction book"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    style={{ width: '100%' }}
                />
            </div>
            
            <div className="mb-4">
                <h3 className="details-label">Topic</h3>
                <TextArea
                    className="create-textarea character-textarea"
                    placeholder="What is your non-fiction book about? Provide a title and brief description."
                    value={topic}
                    onChange={(e) => setTopic(e.target.value)}
                    style={{ width: '100%', minHeight: '100px' }}
                />
            </div>
            
            <div className="mb-4">
                <h3 className="details-label">Style & Tone</h3>
                <TextArea
                    className="create-textarea character-textarea"
                    placeholder="Describe the writing style and tone (e.g., formal academic, conversational, instructional)"
                    value={styleAndTone}
                    onChange={(e) => setStyleAndTone(e.target.value)}
                    style={{ width: '100%', minHeight: '100px' }}
                />
            </div>
            
            <div className="mb-4">
                <h3 className="details-label">Other Instructions</h3>
                <TextArea
                    className="create-textarea character-textarea"
                    placeholder="Any other specific instructions or preferences for your non-fiction book"
                    value={otherInstructions}
                    onChange={(e) => setOtherInstructions(e.target.value)}
                    style={{ width: '100%', minHeight: '100px' }}
                />
            </div>
        </div>
    );
};

export default Information;
